import { h, svgUse } from '../utils/dom.js';
import { t, getLang } from '../i18n/index.js';
import { api } from '../api/client.js';
import { ENDPOINTS } from '../api/endpoints.js';
import { emit, EVENT } from '../utils/events.js';
import { setPendingScenario } from '../utils/sessionStore.js';
import { recordScenarioOpened } from '../utils/activityStore.js';
import { Loader } from '../components/common/Loader.js';
import { ErrorState } from '../components/common/ErrorState.js';
import { EmptyState } from '../components/common/EmptyState.js';

export function ScenariosPage() {
  const root = h('div', { class: 'page active' });
  root.appendChild(Loader());

  api.get(ENDPOINTS.scenarios.list()).then((scenarios) => {
    root.innerHTML = '';
    const lang = getLang();
    const items = scenarios || [];

    root.appendChild(
      h('section', { class: 'scenario-hero' },
        h('div', { class: 'scenario-hero-copy' },
          h('span', { class: 'eyebrow' }, t('scenarioEyebrow')),
          h('h1', {}, t('scenariosTitle')),
          h('p', {}, t('scenariosDesc')),
          h('div', { class: 'scenario-hero-meta' },
            h('span', {}, svgUse('ic-books'), `${items.length} ${t('scenarioCount')}`),
            h('span', {}, svgUse('ic-bulb'), t('instantFeedback')),
          ),
        ),
        h('div', { class: 'scenario-hero-art', 'aria-hidden': 'true' },
          h('span', { class: 'orbit orbit-one' }, svgUse('ic-target')),
          h('span', { class: 'orbit orbit-two' }, svgUse('ic-star')),
          h('img', { src: '/ludus-study-companion.png', alt: '' }),
        ),
      ),
    );

    if (!items.length) {
      root.appendChild(EmptyState());
      return;
    }

    const grid = h('div', { class: 'scenario-grid' });
    items.forEach((scenario, index) => {
      const title = lang === 'ar'
        ? (scenario.title_ar || scenario.title_en)
        : (scenario.title_en || scenario.title_ar);
      const context = scenario.scenario_context || '';
      const icon = ['ic-leaf', 'ic-flask', 'ic-eye'][index % 3];

      grid.appendChild(
        h('button', {
          class: `scenario-card tone-${(index % 3) + 1}`,
          type: 'button',
          onclick: () => {
            recordScenarioOpened(scenario);
            setPendingScenario(scenario.id);
            emit(EVENT.TAB_REQUESTED, 'session');
          },
        },
          h('span', { class: 'scenario-number' }, String(index + 1).padStart(2, '0')),
          h('span', { class: 'scenario-icon' }, svgUse(icon)),
          h('span', { class: 'scenario-copy' },
            h('strong', {}, title),
            h('span', {}, context.slice(0, 135) + (context.length > 135 ? '…' : '')),
          ),
          h('span', { class: 'scenario-start' }, t('startScenario'), svgUse('ic-chevr', 'flip-x')),
        ),
      );
    });
    root.appendChild(grid);

    root.appendChild(
      h('section', { class: 'scenario-steps' },
        h('div', { class: 'scenario-steps-head' },
          h('span', { class: 'eyebrow' }, t('simpleSteps')),
          h('h2', {}, t('scenariosHowTitle')),
        ),
        h('div', { class: 'scenario-steps-grid' },
          step('01', 'ic-eye', t('scenarioStep1T'), t('scenarioStep1D')),
          step('02', 'ic-bulb', t('scenarioStep2T'), t('scenarioStep2D')),
          step('03', 'ic-star', t('scenarioStep3T'), t('scenarioStep3D')),
        ),
      ),
    );
    root.appendChild(h('p', { class: 'tagline-strip' }, t('tagline')));
  }).catch(() => {
    root.innerHTML = '';
    root.appendChild(ErrorState({ onRetry: () => location.reload() }));
  });

  return root;
}

function step(number, icon, title, desc) {
  return h('div', { class: 'scenario-step' },
    h('span', { class: 'step-number' }, number),
    h('span', { class: 'step-icon' }, svgUse(icon)),
    h('strong', {}, title),
    h('p', {}, desc),
  );
}
